import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "./pages/Dashboard";
import CommandCentre from "./pages/CommandCentre";
import Login from "./pages/Login";
import AgentDashboard from "./pages/AgentDashboard";
import ClientPortal from "./pages/ClientPortal";
import ClientDashboards from "./pages/ClientDashboards";
import SQLCopilotAdmin from "./pages/SQLCopilotAdmin";
import Runbooks from "./pages/Runbooks";
import QuoteView from "./pages/QuoteView";
import MyWorkPage from "./pages/MyWorkPage";
import HealthCheckPublicPage from "./pages/HealthCheckPublicPage";
import "@/App.css";

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/agent" element={<AgentDashboard />} />
          <Route path="/client" element={<ClientPortal />} />
          <Route path="/dashboards" element={<ClientDashboards />} />
          <Route path="/dashboards/:clientId" element={<ClientDashboards />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/company/overview" element={<Dashboard initialTab="company_overview" />} />
          <Route path="/company/to-dos" element={<Dashboard initialTab="company_todos" />} />
          <Route path="/company/todos" element={<Navigate to="/company/to-dos" replace />} />
          <Route path="/company/actions" element={<Navigate to="/company/to-dos" replace />} />
          <Route path="/my-work" element={<MyWorkPage />} />
          <Route path="/customer-success/clients" element={<Dashboard initialTab="cs_clients" />} />
          <Route path="/customer-success/journey" element={<Dashboard initialTab="cs_journey" />} />
          <Route path="/customer-success/health-checks" element={<Dashboard initialTab="cs_health_checks" />} />
          <Route path="/health-checks/:id" element={<Dashboard initialTab="cs_health_checks" recordType="health_check_submission" />} />
          <Route path="/health-check/:id/staff" element={<Dashboard initialTab="cs_health_checks" recordType="health_check_staff" />} />
          <Route path="/health-check" element={<HealthCheckPublicPage />} />
          <Route path="/health-check/:clientId" element={<HealthCheckPublicPage />} />
          <Route path="/company/meetings" element={<Dashboard initialTab="company_meetings" />} />
          <Route path="/company/billing" element={<Dashboard initialTab="company_billing" />} />
          <Route path="/administration" element={<Dashboard initialTab="administration" />} />
          <Route path="/administration/integrations" element={<Dashboard initialTab="admin_integrations" />} />
          <Route path="/company/goals" element={<Dashboard initialTab="company_goals" />} />
          <Route path="/company/focus" element={<Dashboard initialTab="company_focus" />} />
          <Route path="/sales/prospects" element={<Dashboard initialTab="sales_prospects" />} />
          <Route path="/sales/quotes" element={<Dashboard initialTab="sales_quotes" />} />
          <Route path="/prospects/:id/email" element={<Dashboard initialTab="sales_prospects" recordType="prospect_email" />} />
          <Route path="/prospects/:id" element={<Dashboard initialTab="sales_prospects" recordType="prospect" />} />
          <Route path="/clients/:id/email" element={<Dashboard initialTab="cs_clients" recordType="client_email" />} />
          <Route path="/clients/:id" element={<Dashboard initialTab="cs_clients" recordType="client" />} />
          <Route path="/quotes/new" element={<Dashboard initialTab="sales_quotes" recordType="quote_new" />} />
          <Route path="/quotes/:id/edit" element={<Dashboard initialTab="sales_quotes" recordType="quote_edit" />} />
          <Route path="/quotes/:id" element={<Dashboard initialTab="sales_quotes" recordType="quote_view" />} />
          <Route path="/tickets" element={<Dashboard initialTab="tickets" />} />
          <Route path="/calls" element={<Dashboard initialTab="calls" />} />
          <Route path="/companies" element={<Dashboard initialTab="companies" />} />
          <Route path="/compliance" element={<Dashboard initialTab="compliance" />} />
          <Route path="/recordings" element={<Dashboard initialTab="recordings" />} />
          <Route path="/alerts" element={<Dashboard initialTab="alerts" />} />
          <Route path="/agents" element={<Dashboard initialTab="agents" />} />
          <Route path="/settings" element={<Dashboard initialTab="settings" />} />
          <Route path="/command-centre" element={<CommandCentre />} />
          <Route path="/tv" element={<CommandCentre />} />
          <Route path="/sql-copilot" element={<SQLCopilotAdmin />} />
          <Route path="/runbooks" element={<Runbooks />} />
          <Route path="/quote/:token" element={<QuoteView />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        theme="light"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #DAD5CA',
            color: '#1A1A1A'
          }
        }}
      />
    </div>
  );
}

export default App;
